import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
	storeCode: null,
	mobile:'',
	nickname:'',
	bookingnum:0, 
	commennum:0,
	memberCode:null,
	unionId: null
}
export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js